/**
 * @documental
 * @export TabPane
 * @name
 * TabbedContainer.TabPane
 */

import { FC, ReactNode } from "react";
import { TabProps } from "../TabSet";

/**
 * The tab pane component properties.
 */
export interface TabPaneProps extends Omit<TabProps, "role"> {
  /**
   * The tab label.
   */
  readonly label: ReactNode;

  /**
   * The tab tooltip. The tooltip appearance is able to be adjusted on the parent `TabbedContainer` component.
   */
  readonly tooltip?: ReactNode;

  /**
   * Indicates whether a non-focused tab keeps its content in the DOM. If not specified defaults to `false`.
   */
  readonly keepHiddenContentInDOM?: boolean;

  /**
   * The tab pane children.
   */
  readonly children?: ReactNode;
}

/**
 * Represents a single tab pane which can be placed within the TabbedContainer component.
 */
export const TabPane: FC<TabPaneProps> = () => {
  return null;
};
